import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../../guards/user-permissions.guard'
import { SharedModule } from '../../../../shared/shared.module'
import { PriceAgreementHistoryDetailComponent } from './price-agreement-history-detail.component'

@NgModule({
  declarations: [PriceAgreementHistoryDetailComponent],
  imports: [RouterModule, UrlModule, SharedModule, SpinnerModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        PriceSupportAgreementDetailsComponent: {
          component: PriceAgreementHistoryDetailComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class PriceAgreementHistoryDetailModule {}
